/* This array stores the rules disabled due to a deleted reply template.
 * When a template is deleted, the server clears AutoReplyWithTemplate from the rule,
 * so we can no longer detect the template reference from the rule data alone.
 * This cache records which rule IDs were disabled by template deletion so the UI
 * can show the correct warning message.
 *
 *  [ ruleIds]
 */
export const disabledTemplateRulesCache: string[] = [];
